import { useEcranAide, useDemandeEcran } from './aide/AideContexte';
import React, { useState } from 'react';
import { departementCourant, peutModifier } from '../services/droits';
import StageCertifParametrage from './StageCertifParametrage';
import StageCertifTableauBord from './StageCertifTableauBord';

/**
 * SUIVI DE STAGE — onglet CERTIFICATION (lot C.0)
 * ================================================
 * Spec     : doc/modules/suivi_de_stage_certification.md
 * Maquette : doc/maquettes/suivi_de_stage_maquette.html (#tab-certification)
 *
 * Deux écrans, en pastilles comme la maquette (même motif que les sous-onglets
 * du Paramétrage), avec la phrase d'explication alignée à droite :
 *   Tableau de bord ✅ lot C.1 — lecture, panneau, contrôle aléatoire ; l'envoi (C30) au lot C.4
 *   Paramétrage     ✅ lot C.0 — les processus
 *
 * Le compteur de l'onglet (C23, CB4) est lu par la coquille du module (SuiviStageModule).
 * `onAller` : « Compléter le contact » ouvre l'onglet où corriger (CB3).
 */

const ECRANS = [
    { cle: 'dash',  libelle: 'Tableau de bord', icone: 'fa-chart-bar' },
    { cle: 'param', libelle: 'Paramétrage',     icone: 'fa-gear' }
];

/**
 * Lot L1a (E169) — DANS UNE VIGNETTE de certification : `onglet` ('processus' | 'modeles' | 'attestations' | 'dash')
 * est piloté par les onglets numérotés de la vignette, et `processusId` limite tout à CE processus (les pastilles
 * et le choix du processus disparaissent). Sans `onglet` : la vue d'ensemble (tableau de bord, tous les processus).
 */
function StageCertification({ config, user, anneeId, onAller, onglet = null, processusId = null, onEcrit = null, onSupprime = null, vueEnsemble = false, rechercheInitiale = '', manquants = [] }) {
    const [ecranLibre, setEcran] = useState('dash');
    const ecran = onglet ? (onglet === 'dash' ? 'dash' : 'param') : ecranLibre;
    // Aide contextuelle (A1)
    useEcranAide('certification/' + (ecran === 'param' ? 'param' : 'tableau'));
    useDemandeEcran('certification', (s) => { if (s === 'tableau') setEcran('dash'); else if (s === 'param') setEcran('param'); });
    const departementId = departementCourant(user, config);
    const modifiable = peutModifier(user, departementId, 'stage');

    if (!departementId) {
        return (
            <div className="stg-encart stg-encart-alerte">
                <i className="fa-solid fa-triangle-exclamation" />
                <span>Aucun département n'est sélectionné : la certification ne peut pas être lue.</span>
            </div>
        );
    }

    return (
        <>
            <div className="certif-entete">
                {!onglet && (
                <div className="param-subtab-bar" role="tablist" aria-label="Écrans de la certification">
                    {ECRANS.map((e) => (
                        <button key={e.cle} type="button" role="tab" aria-selected={ecran === e.cle}
                                className={'param-subtab' + (ecran === e.cle ? ' active' : '')}
                                onClick={() => setEcran(e.cle)}>
                            <i className={'fa-solid ' + e.icone} /> {e.libelle}
                        </button>
                    ))}
                </div>
                )}
                <div className="certif-entete-info">
                    <i className="fa-solid fa-circle-info" /> Chaque document remis est attesté, un par un, par le maître de stage ou d'apprentissage.
                </div>
            </div>

            {ecran === 'dash' && (
                <StageCertifTableauBord departementId={departementId} anneeId={anneeId} modifiable={modifiable} onAller={onAller}
                                        processusFixe={processusId} vueEnsemble={vueEnsemble} rechercheInitiale={rechercheInitiale} />
            )}

            {ecran === 'param' && (
                <StageCertifParametrage departementId={departementId} anneeId={anneeId} modifiable={modifiable}
                                        onglet={onglet} processusId={processusId} onEcrit={onEcrit} onSupprime={onSupprime} manquants={manquants} />
            )}
        </>
    );
}

export default StageCertification;
